// 48개 지역 레이어
export const countiesFillLayer = {
    id: 'countiesFill',
    type: 'fill',
    source: 'areaDataUrl',
    // 'source-layer': 'original',
    paint: {
        'fill-outline-color': '#9baaf3',
        'fill-color': '#dfd1fa',
        'fill-opacity': 0.1
    }
};

export const countiesLayer = {
    id: `countiesLine`,
    type: "line",
    // source: 'areaDataUrl',
    // layout: {},
    paint: {
        "line-color": "#9baaf3",
        "line-width": 1,
        "line-opacity": 0.5,
    },
};

// 48개 지역 중 지도에서 클릭 또는 마우스 호버로 선택된 레이어
export const highlightLayer = {
    id: 'counties-highlighted',
    type: 'fill',
    source: 'areaDataUrl',
    // 'source-layer': 'original',
    paint: {
        // 'fill-outline-color': '#E1A200',
        'fill-color': '#dfd1fa',
        'fill-opacity': 0.2
    }
};

// 48개 지역 중 드롭다운으로 선택된 레이어
export const highlightLayer2 = {
    id: 'counties-highlighted2',
    type: 'fill',
    // source: 'areaDataUrl',
    // 'source-layer': 'original',
    paint: {
        // 'fill-outline-color': '#E1A200',
        'fill-color': '#dfd1fa',
        'fill-opacity': 0.3
    }
};

export const highlightLayer2Line = {
    id: `counties-highlighted2-line`,
    type: "line",
    source: 'areaDataUrl',
    // layout: {},
    paint: {
        "line-color": "#E1A200",
        "line-width": 1,
    },
};

// 연도별 데이터 fill - mud
export const yearFillLayer = {
    id: `mudYearFillLayer`,
    type: "fill",
    source: `data`,
    layout: {
        'visibility': 'visible',
    },
    paint: {
        "fill-color": "#AB5133", // mud color fill
        "fill-opacity": 0.5,
    },
};

// 연도별 데이터 outline - mud
export const yearLineLayer = {
    id: `mudYearOutlineLayer`,
    type: "line",
    source: 'data',
    layout: {},
    paint: {
        "line-color": "#AB5133",
        "line-width": 1,
    },
};

// 연도별 데이터 fill - seaweed (해초대)
export const yearFillLayerSeaweed = {
    id: `locationsSeaweed`,
    type: "fill",
    source: `data`,
    layout: {
        'visibility': 'visible',
    },
    paint: {
        "fill-color": "#005DCB",
        "fill-opacity": 0.5,
    },
};

// 연도별 데이터 outline - seaweed (해초대)
export const yearLineLayerSeaweed = {
    id: `outlineSeaweed`,
    type: "line",
    source: 'data',
    layout: {},
    paint: {
        "line-color": "#005DCB",
        "line-width": 1,
    },
};

// 연도별 데이터 fill - salt (염습지)
export const yearFillLayerSalt = {
    id: `locationsSeaweed`,
    type: "fill",
    source: `data`,
    layout: {
        'visibility': 'visible',
    },
    paint: {
        "fill-color": "#328400",
        "fill-opacity": 0.5,
    },
};

// 연도별 데이터 outline - salt (염습지)
export const yearLineLayerSalt = {
    id: `outlineSeaweed`,
    type: "line",
    source: 'data',
    layout: {},
    paint: {
        "line-color": "#328400",
        "line-width": 1,
    },
};

/* 현장조사 */
// 48개 지역 레이어
export const countiesLayerInvestigation = {
    id: 'countiesInvestigation',
    type: 'fill',
    // 'source-layer': 'original',
    paint: {
        'fill-outline-color': '#FFFFFF',
        'fill-color': '#DDDDDD',
        'fill-opacity': 0.2
    }
};

// 48개 지역 중 지도에서 클릭 또는 마우스 호버로 선택된 레이어
export const highlightLayerInvestigation = {
    id: 'counties-highlightedInvestigation',
    type: 'fill',
    // source: 'areaDataUrl',
    // 'source-layer': 'original',
    paint: {
        'fill-outline-color': '#B28100',
        'fill-color': '#fff',
        'fill-opacity': 0.4
    }
};

// 48개 지역 중 드롭다운으로 선택된 레이어
export const highlightLayer2Investigation = {
    id: 'counties-highlighted2Investigation',
    type: 'fill',
    source: 'areaDataUrl',
    // 'source-layer': 'original',
    paint: {
        'fill-outline-color': '#B28100',
        'fill-color': '#fff',
        'fill-opacity': 0.4
    }
};

// 현장조사 정점 그룹핑 레이어
export const clusterLayer = {
    id: 'clusters',
    type: 'circle',
    source: 'investigation',
    filter: ['has', 'point_count'],
    paint: {
        'circle-color': ['step', ['get', 'point_count'], '#E1A200', 100, '#97482d', 550, '#AB5133'],
        'circle-radius': ['step', ['get', 'point_count'], 20, 200, 30, 750, 40]
    }
};

export const clusterCountLayer = {
    id: 'cluster-count',
    type: 'symbol',
    source: 'investigation',
    filter: ['has', 'point_count'],
    layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12
    }
};

export const unclusteredPointLayer = {
    id: 'unclustered-point',
    type: 'circle',
    source: 'investigation',
    filter: ['!', ['has', 'point_count']],
    paint: {
        'circle-color': '#AB5133',
        'circle-radius': 6,
        'circle-stroke-width': 2,
        'circle-stroke-color': '#fff',
    }
};

export const unclusteredPointHighlightLayer = {
    id: `unclustered-point-highlighted`,
    type: "circle",
    source: 'investigation',
    // layout: {},
    paint: {
        'circle-color': 'red',
        'circle-radius': 8,
        'circle-stroke-width': 2,
        'circle-stroke-color': '#fff',
    }
};

// 현장조사 정점 그룹핑 레이어
export const clusterLayerSeaweed = {
    id: 'clustersSeaweed',
    type: 'circle',
    source: 'investigationSeaweed',
    filter: ['has', 'point_count'],
    paint: {
        'circle-color': ['step', ['get', 'point_count'], '#00c3cb', 100, '#0800cb', 750, '#005DCB'],
        'circle-radius': ['step', ['get', 'point_count'], 20, 200, 30, 750, 40]
    }
};

export const clusterCountLayerSeaweed = {
    id: 'cluster-countSeaweed',
    type: 'symbol',
    source: 'investigationSeaweed',
    filter: ['has', 'point_count'],
    layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12
    }
};

export const unclusteredPointLayerSeaweed = {
    id: 'unclustered-pointSeaweed',
    type: 'circle',
    source: 'investigationSeaweed',
    filter: ['!', ['has', 'point_count']],
    paint: {
        'circle-color': '#005DCB',
        'circle-radius': 8,
        'circle-stroke-width': 2,
        'circle-stroke-color': '#fff',
        // 'circle-stroek-opacity': '0.1'
    }
};

// 현장조사 정점 그룹핑 레이어
export const clusterLayerSalt = {
    id: 'clustersSalt',
    type: 'circle',
    source: 'investigationSalt',
    filter: ['has', 'point_count'],
    paint: {
        'circle-color': ['step', ['get', 'point_count'], '#748400', 100, '#008410', 750, '#328400'],
        'circle-radius': ['step', ['get', 'point_count'], 20, 200, 30, 750, 40]
    }
};

export const clusterCountLayerSalt = {
    id: 'cluster-countSalt',
    type: 'symbol',
    source: 'investigationSalt',
    filter: ['has', 'point_count'],
    layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12,
    }
};

export const unclusteredPointLayerSalt = {
    id: 'unclustered-pointSalt',
    type: 'circle',
    source: 'investigationSalt',
    filter: ['!', ['has', 'point_count']],
    paint: {
        'circle-color': '#328400',
        'circle-radius': 8,
        'circle-stroke-width': 2,
        'circle-stroke-color': '#fff',
        // 'circle-stroek-opacity': '0.1'
    }
};
